<script setup>
import { ref, computed, defineEmits, defineExpose } from "vue";
const props = defineProps({
  modelValue: { type: String },
  label: {
    type: String,
    default: '회사 직통번호',
  },
  placeholder: {
    type: String,
    default: "'-' 입력 제외",
  },
  msg: {
    type: String,
    default: '',
  },
  msgColor: {
    type: String,
    default: '#ff0000'
  },
  disabled: {
    type: Boolean,
    default: false
  },
});
const emit = defineEmits(["update:modelValue"]);
const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const inputRef = ref(null)

const getPhoneMask = () => {
  let res = getMask()
  // console.log(res);
  emit("update:modelValue", res);
}

const getMask = ( ) => {
  let str = props.modelValue
  str = str.replace(/[^0-9]/g, '');

  // 15XX / 16XX / 18XX 대표번호
  const representativeNumberPattern = /^(15|16|18)\d{2}/
  if (representativeNumberPattern.test(str)) {
    // 1577-1234
    if (str.length > 4)
      str = str.replace(/^(\d{4})(\d{0,4})$/, '$1-$2')
    return str
  } else if( str.startsWith('02')){
    if (str.length > 2 && str.length <= 5) {
      // 02-xxx (입력 중)
      str = str.replace(/^(\d{2})(\d{0,3})$/, (_, a, b) => (b ? `${a}-${b}` : a));
    }
    else if (str.length >= 6 && str.length <= 8) {
      // 6~8자리: 02-1234 / 02-1234-5 등 (중간에 4자리 중간부 표시)
      str = str.replace(/^(\d{2})(\d{4})(\d{0,4})$/, (_, a, b, c) => (c ? `${a}-${b}-${c}` : `${a}-${b}`));
    }
    else if (str.length === 9) {
      // 정확히 9자리일 때는 02-123-4567 (2-3-4)
      str = str.replace(/^(\d{2})(\d{3})(\d{4})$/, '$1-$2-$3');
    }
    else if (str.length === 10) {
      // 02-1234-5678 (2-4-4)
      str = str.replace(/^(\d{2})(\d{4})(\d{4})$/, '$1-$2-$3');
    }
    else if (str.length > 10) {
      // 초과 입력 방지: 최대 10자리로 자름
      str = str.substring(0, 10).replace(/^(\d{2})(\d{4})(\d{4})$/, '$1-$2-$3');
    }
    return str;
  }else {
    // 그 외 지역번호(031, 051...) 또는 휴대폰
    if (str.length <= 3)
      str = str
    else if (str.length <= 6)
      str = str.replace(/^(\d{3})(\d{0,3})$/, '$1-$2')
    else if (str.length === 10)
      str = str.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3') // 고정: 3-3-4
    else if (str.length === 11)
      str = str.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3') // 휴대폰: 3-4-4
    else
      str = str.substring(0, 11)
    return str;
  }
}

const getValue = () => {
  // console.log(inputRef.value.value)
  return inputRef.value.value;
}

defineExpose({
  getValue
})
</script>

<template>
  <div>
    <label>
      <p v-if="label">{{ label }}</p>
      <input ref="inputRef" type="text" v-model="model" @input="getPhoneMask" :placeholder="placeholder" :maxlength="13" :disabled="disabled">
    </label>
    <div v-if="msg" :style="{'color': msgColor || $color.labelcolor}"><small>{{ msg }}</small></div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../assets/scss/ui-components/ksa_input";

label {
  p {
    @include font-size_xs;
    color: $gray_color;
  }
}
input {
  &:disabled {
    color: $black_color;
    background: $gray-thin_color;
  }
}
</style>